module.exports = __webpack_public_path__ + "fonts/proximanova-semibold-webfont.637fa66e.ttf";